// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dachsbun: PokeData = {
  "id": 927,
  "name": "dachsbun",
  "height": 5,
  "weight": 149,
  "base_experience": 167,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "tail-whip",
    "bite",
    "growl",
    "roar",
    "lick",
    "charm",
    "baton-pass",
    "crunch",
    "covet",
    "last-resort",
    "work-up",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "bite",
    "growl",
    "lick",
    "crunch",
    "play-rough",
    "moonlight",
    "guardian-bond",
    "mist-terrain",
    "heal-bell",
    "hyper-voice",
    "sweet-kiss",
    "spirit-break"
  ],
  "evolution_chain": {
    "id": 486,
    "item": null,
    "species": [
      {
        "name": "fidough",
        "order": 970,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dachsbun",
        "order": 971,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 926,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 151,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
